/* Pielle · bloque de reseñas · 28/09/2026 · lo carga sections/pielle-resenas.liquid */
/* 07/10/2026 · velocidad: cada tarjeta llega dentro de un <template> (no entra al DOM).
   Solo se pegan en la página las tarjetas que se ven (la tanda actual). Antes estaban
   las 228 en el DOM (9.300 nodos, 82% de la página) y se re-ordenaban todas al cargar. */
(function(){
  var wrap = document.getElementById('plr-wrap');
  if (!wrap || wrap.__plr) return; wrap.__plr = true;

  /* entrada de bloques (mismo ayudante idempotente del resto de la landing) */
  if (window.__plReveal) window.__plReveal();

  var sec = wrap.querySelector('.plr');
  var list = wrap.querySelector('[data-plr-list]');
  if (!list) return;

  var PAGE = parseInt(wrap.getAttribute('data-plr-page'), 10) || 6;
  /* tarjetas: dentro de <template data-plr-t> (nuevo) o directo en la lista (versión anterior) */
  var cards = [];
  Array.prototype.forEach.call(list.querySelectorAll('template[data-plr-t]'), function(t){
    var c = t.content && t.content.querySelector('.plr-rev');
    if (c) cards.push(c);
  });
  if (!cards.length) cards = Array.prototype.slice.call(list.querySelectorAll('.plr-rev'));
  var isDemo = cards.some(function(c){ return c.classList.contains('plr-rev--demo'); });
  var empty = list.querySelector('[data-plr-empty]');
  var moreWrap = wrap.querySelector('[data-plr-morewrap]');
  var status = wrap.querySelector('[data-plr-status]');
  var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-plr-tab]'));
  var distBtns = Array.prototype.slice.call(wrap.querySelectorAll('[data-plr-stars]'));
  var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-plr-q]'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function norm(s){ return (s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase(); }
  /* 30/09/2026 · los chips buscan por raíz (5 letras): "hidratación" cuenta también
     hidrata, hidratada, hidratante. Antes buscaban la palabra exacta y daban 4 o 1. */
  var CHIP_MIN = 5;
  function chipKey(b){ var s = norm(b.getAttribute('data-plr-q')).trim(); return s.length > 5 ? s.slice(0,5) : s; }
  cards.forEach(function(c){ c.__q = norm(c.getAttribute('data-q')); });
  function num(c, a){ return parseFloat(c.getAttribute(a)) || 0; }

  /* estado */
  var st = { tab:'relevantes', stars:null, q:null, shown:PAGE };

  function score(c){
    /* "Más relevantes": destacadas, con foto, con texto desarrollado y mejor puntaje primero */
    return num(c,'data-d')*1000 + num(c,'data-f')*120 + Math.min(num(c,'data-l'),600)/6 + num(c,'data-s')*18 + num(c,'data-v')*25;
  }
  function matches(c){
    var s = num(c,'data-s');
    if (st.tab === '5' && s !== 5) return false;
    if (st.tab === '4' && s !== 4) return false;
    if (st.tab === 'criticas' && s > 3) return false;
    if (st.tab === 'fotos' && num(c,'data-f') !== 1) return false;
    if (st.stars && s !== st.stars) return false;
    if (st.q && c.__q.indexOf(st.q) === -1) return false;
    return true;
  }
  function sorted(arr){
    var a = arr.slice();
    if (st.tab === 'recientes') a.sort(function(x,y){ return num(y,'data-t') - num(x,'data-t') || num(x,'data-i') - num(y,'data-i'); });
    else a.sort(function(x,y){ return score(y) - score(x) || num(x,'data-i') - num(y,'data-i'); });
    return a;
  }

  function render(animate){
    var vis = sorted(cards.filter(matches));
    /* saca de la lista las tarjetas que estaban pegadas; quedan guardadas en memoria */
    cards.forEach(function(c){ if (c.parentNode === list) list.removeChild(c); });
    var frag = document.createDocumentFragment();
    vis.forEach(function(c, i){
      if (i >= st.shown) return;
      c.hidden = false;
      frag.appendChild(c);
      if (animate && !reduce){
        c.classList.add('is-entering');
        (function(el, d){ setTimeout(function(){ el.classList.remove('is-entering'); }, 30 + d); })(c, Math.min(i, 8) * 45);
      }
    });
    list.insertBefore(frag, empty);
    empty.hidden = vis.length !== 0;
    if (moreWrap) moreWrap.hidden = vis.length <= st.shown;
    var partes = [];
    if (st.stars) partes.push(st.stars + ' estrellas');
    if (st.q) partes.push('“' + activeChipLabel() + '”');
    if (status){
      if (partes.length){
        status.innerHTML = '';
        status.appendChild(document.createTextNode(vis.length + (vis.length === 1 ? ' reseña' : ' reseñas') + ' con ' + partes.join(' y ') + '.'));
        var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Ver todas';
        b.addEventListener('click', function(){ st.stars = null; st.q = null; syncPressed(); st.shown = PAGE; render(true); });
        status.appendChild(b);
      } else {
        status.textContent = vis.length ? ('Mostrando ' + Math.min(st.shown, vis.length) + ' de ' + vis.length) : '';
      }
    }
    checkClamp();
  }
  function activeChipLabel(){
    for (var i=0;i<chips.length;i++) if (chips[i].getAttribute('aria-pressed') === 'true') return chips[i].firstChild.textContent.trim();
    return st.q;
  }
  function syncPressed(){
    distBtns.forEach(function(b){ b.setAttribute('aria-pressed', String(st.stars === parseInt(b.getAttribute('data-plr-stars'),10))); });
    chips.forEach(function(b){ b.setAttribute('aria-pressed', String(st.q === chipKey(b))); });
    tabs.forEach(function(t){ t.setAttribute('aria-selected', String(t.getAttribute('data-plr-tab') === st.tab)); });
  }
  function scrollToList(){
    var bar = wrap.querySelector('[data-plr-bar]');
    if (!bar) return;
    var r = bar.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * .6) bar.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block:'start' });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      st.tab = t.getAttribute('data-plr-tab'); st.shown = PAGE;
      if (st.tab === '5' || st.tab === '4' || st.tab === 'criticas') st.stars = null;
      syncPressed(); render(true);
    });
  });
  /* teclado en pestañas: flechas */
  var tablist = wrap.querySelector('[role="tablist"]');
  if (tablist) tablist.addEventListener('keydown', function(e){
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var i = tabs.indexOf(document.activeElement); if (i < 0) return;
    var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    n.focus(); n.click(); e.preventDefault();
  });
  distBtns.forEach(function(b){
    b.addEventListener('click', function(){
      var n = parseInt(b.getAttribute('data-plr-stars'), 10);
      st.stars = st.stars === n ? null : n;
      if (st.stars && (st.tab === '5' || st.tab === '4' || st.tab === 'criticas' || st.tab === 'fotos')) st.tab = 'relevantes';
      st.shown = PAGE; syncPressed(); render(true); scrollToList();
    });
  });
  chips.forEach(function(b){
    var q = chipKey(b);
    var n = cards.filter(function(c){ return c.__q.indexOf(q) !== -1; }).length;
    var em = b.querySelector('[data-plr-qn]'); if (em) em.textContent = n;
    if (n < CHIP_MIN) { b.parentNode.hidden = true; return; }
    b.addEventListener('click', function(){
      st.q = st.q === q ? null : q; st.shown = PAGE; syncPressed(); render(true); scrollToList();
    });
  });
  var loadMore = wrap.querySelector('[data-plr-loadmore]');
  if (loadMore) loadMore.addEventListener('click', function(){ st.shown += PAGE; render(true); });

  /* "Leer más" solo donde el texto quedó cortado (solo tarjetas pegadas en la página) */
  function checkClamp(){
    cards.forEach(function(c){
      if (c.parentNode !== list || c.hidden || c.__clampChecked) return;
      var t = c.querySelector('.plr-rev__text'), m = c.querySelector('[data-plr-more]');
      if (!t || !m) return;
      c.__clampChecked = true;
      if (t.scrollHeight > t.clientHeight + 2) m.hidden = false;
    });
  }
  list.addEventListener('click', function(e){
    var m = e.target.closest('[data-plr-more]');
    if (m){ var c = m.closest('.plr-rev'); var open = c.classList.toggle('is-open'); m.textContent = open ? 'Leer menos' : 'Leer más'; return; }
  });

  /* "Útil" · contador compartido (Cloudflare Worker) con respaldo local */
  function store(){ try { return window.localStorage; } catch(e){ return null; } }
  var ls = store();
  var API = (wrap.getAttribute('data-plr-api') || '').replace(/\/+$/, '');
  function lsGet(k){ try { return ls ? ls.getItem(k) : null; } catch(e){ return null; } }
  function lsSet(k, v){ try { if (ls) { if (v === null) ls.removeItem(k); else ls.setItem(k, v); } } catch(e){} }
  function votante(){
    var v = lsGet('plr-votante');
    if (!v){
      v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID().replace(/-/g, '') :
        (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
      lsSet('plr-votante', v);
    }
    return v;
  }
  function keyOf(c){ return 'plr-util-' + c.getAttribute('data-id'); }
  var counts = {};
  function paintUtil(c){
    var btn = c.querySelector('[data-plr-util]'); if (!btn) return;
    var id = c.getAttribute('data-id'), on = lsGet(keyOf(c)) === '1';
    var n = API ? (counts[id] || 0) : 0;
    btn.setAttribute('aria-pressed', String(on));
    var el = btn.querySelector('[data-plr-util-n]');
    if (el){ el.textContent = n > 0 ? String(n) : ''; el.hidden = !(n > 0); }
    btn.setAttribute('aria-label', 'Útil' + (n > 0 ? ': ' + n + (n === 1 ? ' persona' : ' personas') : '') + (on ? '. Ya lo marcaste' : ''));
  }
  function loadCounts(){
    if (!API || !window.fetch) return;
    var ids = cards.map(function(c){ return c.getAttribute('data-id'); }).filter(Boolean);
    if (!ids.length) return;
    fetch(API + '/utiles?ids=' + encodeURIComponent(ids.join(',')) + '&v=' + encodeURIComponent(votante()), { credentials:'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (!d) return;
        counts = d.counts || {};
        var mine = {}; (d.mine || []).forEach(function(id){ mine[id] = true; });
        cards.forEach(function(c){
          var id = c.getAttribute('data-id');
          lsSet(keyOf(c), mine[id] ? '1' : null);
          paintUtil(c);
        });
      })
      .catch(function(){});
  }
  cards.forEach(function(c){
    var btn = c.querySelector('[data-plr-util]'); if (!btn) return;
    paintUtil(c);
    btn.addEventListener('click', function(){
      var id = c.getAttribute('data-id');
      var now = btn.getAttribute('aria-pressed') !== 'true';
      var prevN = counts[id] || 0;
      lsSet(keyOf(c), now ? '1' : null);
      if (API) counts[id] = Math.max(0, prevN + (now ? 1 : -1));
      paintUtil(c);
      if (now && !reduce){ btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
      if (!API || !window.fetch) return;
      btn.disabled = true;
      fetch(API + '/votar', {
        method:'POST', credentials:'omit', headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ resena:id, votante:votante(), accion: now ? 'sumar' : 'quitar' })
      })
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(d){ if (d && typeof d.n === 'number') counts[id] = d.n; paintUtil(c); })
        .catch(function(){ lsSet(keyOf(c), now ? null : '1'); counts[id] = prevN; paintUtil(c); })
        .then(function(){ btn.disabled = false; });
    });
  });

  /* diálogos */
  function openDlg(d){ if (!d) return; if (d.showModal) { try { d.showModal(); } catch(e){ d.setAttribute('open',''); } } else d.setAttribute('open',''); document.documentElement.style.overflow = 'hidden'; }
  function closeDlg(d){ if (!d) return; if (d.close) d.close(); else d.removeAttribute('open'); }
  Array.prototype.forEach.call(wrap.querySelectorAll('dialog'), function(d){
    d.addEventListener('close', function(){ document.documentElement.style.overflow = ''; });
    d.addEventListener('click', function(e){ if (e.target === d || e.target.closest('[data-plr-close]')) closeDlg(d); });
  });
  var dlgWrite = wrap.querySelector('[data-plr-dlg="write"]');
  Array.prototype.forEach.call(wrap.querySelectorAll('[data-plr-open="write"]'), function(b){
    b.addEventListener('click', function(){ openDlg(dlgWrite); });
  });
  if (dlgWrite && (dlgWrite.querySelector('[data-plr-sent]') || dlgWrite.querySelector('.plr-f__err'))) {
    openDlg(dlgWrite);
  }
  var form = wrap.querySelector('#plr-form');
  if (form) form.addEventListener('submit', function(e){
    var body = form.querySelector('#plr-body'), ok = form.querySelector('.plr-check input'), name = form.querySelector('#plr-name');
    var msg = !name.value.trim() ? name : (body.value.trim().length < 10 ? body : (!ok.checked ? ok : null));
    if (msg){ e.preventDefault(); msg.focus(); if (msg.reportValidity) { msg.setCustomValidity(msg === body ? 'Contanos un poco más (mínimo 10 caracteres).' : ''); msg.reportValidity(); msg.setCustomValidity(''); } }
  });

  /* galería de fotos + visor */
  var withPhoto = function(){ return sorted(cards.filter(function(c){ return num(c,'data-f') === 1; })); };
  var track = wrap.querySelector('[data-plr-photos]');
  var lb = wrap.querySelector('[data-plr-dlg="lb"]');
  var lbImg = lb && lb.querySelector('[data-plr-lb-img]');
  var lbBody = lb && lb.querySelector('[data-plr-lb-body]');
  var lbCount = lb && lb.querySelector('[data-plr-lb-count]');
  var lbSet = [], lbI = 0;
  function showLb(i){
    if (!lbSet.length) return;
    lbI = (i + lbSet.length) % lbSet.length;
    var c = lbSet[lbI], img = c.querySelector('.plr-rev__thumb img');
    lbImg.src = img.getAttribute('data-full');
    lbImg.alt = 'Foto de la reseña de ' + c.querySelector('.plr-rev__name').textContent;
    var main = c.querySelector('.plr-rev__main').cloneNode(true);
    Array.prototype.forEach.call(main.querySelectorAll('[data-plr-more]'), function(x){ x.remove(); });
    lbBody.innerHTML = ''; lbBody.appendChild(main);
    lbCount.textContent = (lbI + 1) + ' / ' + lbSet.length;
    var multi = lbSet.length > 1;
    lb.querySelector('[data-plr-lb-prev]').hidden = !multi;
    lb.querySelector('[data-plr-lb-next]').hidden = !multi;
  }
  function openLb(card){ lbSet = withPhoto(); var i = lbSet.indexOf(card); showLb(i < 0 ? 0 : i); openDlg(lb); }
  if (track){
    withPhoto().forEach(function(c){
      var img = c.querySelector('.plr-rev__thumb img');
      var li = document.createElement('li');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'plr__photo';
      b.setAttribute('aria-label', 'Ver foto de ' + c.querySelector('.plr-rev__name').textContent);
      var im = document.createElement('img'); im.src = img.getAttribute('data-thumb'); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.width = 96; im.height = 96;
      b.appendChild(im); b.addEventListener('click', function(){ openLb(c); });
      li.appendChild(b); track.appendChild(li);
    });
  }
  list.addEventListener('click', function(e){ var t = e.target.closest('[data-plr-lb]'); if (t) openLb(t.closest('.plr-rev')); });
  if (lb){
    lb.querySelector('[data-plr-lb-prev]').addEventListener('click', function(){ showLb(lbI - 1); });
    lb.querySelector('[data-plr-lb-next]').addEventListener('click', function(){ showLb(lbI + 1); });
    lb.addEventListener('keydown', function(e){ if (e.key === 'ArrowLeft') showLb(lbI - 1); if (e.key === 'ArrowRight') showLb(lbI + 1); });
    var x0 = null;
    lb.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive:true });
    lb.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) showLb(lbI + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* barra de filtros pegajosa: queda debajo del header fijo del tema, si lo hay */
  function headerOffset(){
    var h = 0;
    Array.prototype.forEach.call(document.querySelectorAll('sticky-header, .shopify-section-header-sticky, .section-header, header'), function(el){
      var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect(); if (r.top <= 1 && r.bottom > 0 && r.bottom < 200) h = Math.max(h, r.bottom);
    });
    wrap.style.setProperty('--plr-top', Math.round(h) + 'px');
  }
  window.addEventListener('scroll', function(){ if (!headerOffset.t) headerOffset.t = setTimeout(function(){ headerOffset.t = 0; headerOffset(); }, 200); }, { passive:true });

  /* sombra cuando la barra queda fija */
  var bar = wrap.querySelector('[data-plr-bar]');
  if (bar && 'IntersectionObserver' in window){
    var sentinel = document.createElement('div'); sentinel.style.height = '1px'; bar.parentNode.insertBefore(sentinel, bar);
    new IntersectionObserver(function(en){ bar.classList.toggle('is-stuck', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(sentinel);
  }

  /* barras de distribución animadas al entrar en pantalla */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){ if (en[0].isIntersecting){ sec.classList.add('is-in'); io.disconnect(); } }, { threshold:.2 });
    io.observe(sec.querySelector('.plr__top') || sec);
  } else sec.classList.add('is-in');

  /* el puntaje de arriba de la landing lleva a las reseñas */
  function linkTop(){
    var total = parseInt(wrap.getAttribute('data-plr-total'), 10) || 0;
    if (!total) return;
    var go = function(e){ if (e) e.preventDefault(); sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block:'start' }); };
    var avg = wrap.getAttribute('data-plr-avg') || '';
    var demo = isDemo;
    var targets = Array.prototype.slice.call(document.querySelectorAll('.pielle-bundles__rating, [data-plr-link]'));
    /* sello del hero ("★★★★★ 4,6 · Opiniones reales"): lleva a las reseñas y muestra el promedio real */
    Array.prototype.forEach.call(document.querySelectorAll('.pielle-hero__badge'), function(el){
      if (!/opiniones/i.test(el.textContent)) return;
      targets.push(el);
      if (demo || !/^\d,\d$/.test(avg)) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (/\d,\d/.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/\d,\d/, avg); break; } }
    });
    targets.forEach(function(el){
      if (el.__plrLinked || wrap.contains(el)) return; el.__plrLinked = true;
      el.style.cursor = 'pointer';
      el.setAttribute('role', 'link'); el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Ver las ' + total + ' reseñas');
      el.addEventListener('click', go);
      el.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') go(e); });
      var cap = el.querySelector('.pielle-bundles__rating-caption');
      if (cap && !cap.querySelector('.plr-toplink')){
        var a = document.createElement('a'); a.href = '#pielle-resenas'; a.className = 'plr-toplink';
        a.textContent = ' Ver las ' + total + ' reseñas ›';
        a.style.cssText = 'color:#A85A3F;font-weight:700;text-decoration:underline;text-underline-offset:2px;white-space:nowrap;';
        a.addEventListener('click', go);
        cap.appendChild(a);
      }
    });
  }

  /* pista de scroll en las pestañas cuando no entran */
  function tabsFade(){
    if (!tablist) return;
    var over = tablist.scrollWidth > tablist.clientWidth + 4;
    tablist.classList.toggle('is-overflow', over);
    tablist.classList.toggle('is-end', over && tablist.scrollLeft + tablist.clientWidth >= tablist.scrollWidth - 4);
  }
  if (tablist){ tablist.addEventListener('scroll', tabsFade, { passive:true }); window.addEventListener('resize', tabsFade); }

  /* resumen de puntaje de arriba (bloque de compra): mismos números que las reseñas cargadas */
  function syncSummary(){
    var box = document.querySelector('.pielle-bundles__rating');
    if (!box || isDemo) return;
    var c = [0,0,0,0,0,0], n = 0, sum = 0, best4 = null;
    /* mismo orden que antes (el de "Más relevantes"), así la cita de 4★ no cambia */
    sorted(cards).forEach(function(el){
      var s = parseInt(el.getAttribute('data-s'), 10);
      if (s >= 1 && s <= 5){ c[s]++; n++; sum += s; if (s === 4 && !best4 && !/esperaba|andreani|demor|correo|env[ií]o|precio|chico|l[ií]quid|acuos|tarda|pronto|todav[ií]a/i.test(el.getAttribute('data-q') || '')) best4 = el; }
    });
    if (!n) return;
    var avg = Math.round(sum / n * 10) / 10, txt = avg.toFixed(1).replace('.', ',');
    var sc = box.querySelector('.pielle-bundles__rating-score'); if (sc) sc.textContent = txt;
    var st = box.querySelector('.pielle-bundles__rating-stars'); if (st) st.setAttribute('aria-label', 'Calificación promedio ' + txt + ' sobre 5');
    var fg = box.querySelector('.pielle-bundles__rating-stars-fg'); if (fg) fg.style.width = (avg * 20) + '%';
    var pct = [5,4,3,2,1].map(function(k){ return Math.round(c[k] * 100 / n); });
    Array.prototype.forEach.call(box.querySelectorAll('.pielle-bundles__rating-row'), function(row, i){
      if (i > 4) return;
      var b = row.querySelector('.pielle-bundles__rating-bar b'), e = row.querySelector('em');
      if (b) b.style.width = pct[i] + '%'; if (e) e.textContent = pct[i] + '%';
    });
    var rv = box.querySelector('.pielle-bundles__rating-review');
    if (rv){
      if (!best4){ rv.hidden = true; return; }
      var q = rv.querySelector('.pielle-bundles__rating-review-quote'), m = rv.querySelector('.pielle-bundles__rating-review-meta');
      var tx = best4.querySelector('.plr-rev__text, .plr-rev__body p, p'), nm = best4.querySelector('.plr-rev__name');
      if (q && tx) q.textContent = '“' + tx.textContent.trim() + '”';
      if (m) m.textContent = (nm ? nm.textContent.trim() + ' · ' : '') + 'Reseña de 4★ · Compra verificada';
    }
  }

  function init(){ syncPressed(); render(false); linkTop(); syncSummary(); tabsFade(); loadCounts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (location.hash === '#pielle-resenas') setTimeout(function(){ sec.scrollIntoView(); }, 350);
})();
